// extracted by mini-css-extract-plugin
module.exports = {"container":"OnboardingLayout_container__1Iknt"};